/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EliosType } from '../models/EliosType';
import type { PaginatedEliosTypeList } from '../models/PaginatedEliosTypeList';
import type { PatchedEliosType } from '../models/PatchedEliosType';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsEliosTypesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedEliosTypeList
     * @throws ApiError
     */
    public clientsEliosTypesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedEliosTypeList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-elios-types/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns EliosType
     * @throws ApiError
     */
    public clientsEliosTypesCreate({
        requestBody,
    }: {
        requestBody: EliosType,
    }): CancelablePromise<EliosType> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-elios-types/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EliosType
     * @throws ApiError
     */
    public clientsEliosTypesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this elios type.
         */
        id: number,
    }): CancelablePromise<EliosType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-elios-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns EliosType
     * @throws ApiError
     */
    public clientsEliosTypesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this elios type.
         */
        id: number,
        requestBody: EliosType,
    }): CancelablePromise<EliosType> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-elios-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EliosType
     * @throws ApiError
     */
    public clientsEliosTypesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this elios type.
         */
        id: number,
        requestBody?: PatchedEliosType,
    }): CancelablePromise<EliosType> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-elios-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsEliosTypesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this elios type.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-elios-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
